import { useQuery } from "@tanstack/react-query";
import { searchQuery, SEARCH_QUERY_KEY } from "../api/searchV2Api";
import type { SearchContext, SearchQueryParams, SearchQueryResponse } from "../types";
import type { ServerResponse } from "../../../types";

export function useInstantSearch(
  q: string,
  context?: SearchContext,
  filters?: Record<string, number>,
) {
  const params: SearchQueryParams = {
    q,
    context,
    perpage: 10,
    enrich: false,
    ...filters,
  };

  return useQuery({
    queryKey: [...SEARCH_QUERY_KEY, "instant", q, context, filters],
    queryFn: ({ signal }) => searchQuery(params, signal),
    enabled: q.length >= 2,
    select: (res) =>
      (res.data as unknown as ServerResponse<SearchQueryResponse>).payload
        .results,
    staleTime: 30_000,
  });
}
